/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Link} from 'react-router-dom';

import Icon from '../../../../UI/Icon/Icon';
import Options from '../LeftToolbar/Options/Options';
import Ai from './Ai/Ai';

const leftToolbar = () => (
    <ul className="nav navbar-toolbar">
        <li className="nav-item hidden-float" id="toggleMenubar">
            <Link to="#" className="nav-link"  data-toggle="menubar" role="button">
                <Icon iconClass="icon hamburger hamburger-arrow-left">
                    <span className="sr-only">Toggle menubar</span>
                    <span className="hamburger-bar"></span>
                </Icon>
            </Link>
        </li>
        <li className="nav-item hidden-sm-down" id="toggleFullscreen">
            <Link to="#" className="nav-link icon icon-fullscreen" data-toggle="fullscreen" role="button">
                <span className="sr-only">Toggle fullscreen</span>
            </Link>
        </li>
        
        {/* This is for ai search, it will be implimented later */}
        {/* <li className="nav-item hidden-float">
            <Link to="#" className="nav-link icon md-search" data-toggle="collapse" data-target="#site-navbar-search" role="button">
                <span className="sr-only">Ai Search</span>
            </Link>
        </li> */}
        <Options />

        {/* This is for ai search, it will be implimented later */}
        <Ai/>
    </ul>
);

export default leftToolbar;
